import { get, writable } from 'svelte/store';

import { BizCardsService } from '@client/services/bizcards';
import { BizCardsRoutingService } from '@client/services/bizcards-routing';

export const assignments = writable([]);
export const inactiveRoutes = writable([]);
export const loading = writable(true);
export const loadingInactive = writable(true);
export const assignedUsers = writable(0);
export const totalUsers = writable(0);
export const unassigned = writable(0);

let bizcardsByName = {};
let previewCache = {};

export async function loadAssignments() {
  loading.set(true);

  const [result, bizcards] = await Promise.all([BizCardsService.getAssignments(), BizCardsService.getAll()]);

  bizcardsByName = {};
  previewCache = {};

  for (const bc of bizcards) {
    bizcardsByName[bc.rulename] = bc;
  }

  assignments.set(result.assignments);
  totalUsers.set(result.totalUsers);
  assignedUsers.set(result.assignedUsers);
  unassigned.set(result.unassigned);

  loading.set(false);
}

export async function loadInactiveRoutes() {
  loadingInactive.set(true);

  const routes = await BizCardsRoutingService.getAll();
  const assignedNames = new Set(get(assignments).map((a) => a.name));
  const grouped = {};

  for (const r of routes) {
    if (!r.status || !r.blockname || assignedNames.has(r.blockname)) continue;

    if (!grouped[r.blockname]) {
      grouped[r.blockname] = { name: r.blockname, groups: [] };
    }

    const groupNames = (r.sendergroups || []).map((sg) => sg.groupname);
    grouped[r.blockname].groups = [...new Set([...grouped[r.blockname].groups, ...groupNames])];
  }

  inactiveRoutes.set(Object.values(grouped));
  loadingInactive.set(false);
}

async function updateAssignment(action) {
  loading.set(true);

  const results = await action();

  if (results.some((r) => r?.status >= 400)) {
    loading.set(false);
    return false;
  }

  await loadAssignments();
  loadInactiveRoutes();
  return true;
}

export function deleteAssignment(bizcard) {
  return updateAssignment(() => BizCardsRoutingService.deleteRoutesByBizcard(bizcard));
}

export function disableAssignment(bizcard) {
  return updateAssignment(() => BizCardsRoutingService.disableRoutesByBizcard(bizcard));
}

export async function getPreview(blockname) {
  if (previewCache[blockname]) return previewCache[blockname];

  const bc = bizcardsByName[blockname];
  if (!bc) return '';

  const response = await BizCardsService.preview({
    username: 'adminuser',
    scratchblockname: bc.rulename,
    scratchtemplate: bc.htmltemplate,
    scratchparams: bc.params,
    params: bc.params,
    prependLines: 0,
    testData: { testsender: 'adminuser' }
  });

  previewCache[blockname] = response.rendered;
  return response.rendered;
}
